import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { CheckCircleIcon as CheckCircleIconSolid } from "@heroicons/react/solid";
import { useNavigate } from "react-router-dom";
import { Ticket } from "lucide-react";
import QuickTicketSetup from "./QuickTicketSetup";

const ModalEventPublishedSuccess = ({ handleClose, handleGoToDashboard, handleShareEvent, eventId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showTicketSetup, setShowTicketSetup] = useState(false);

  const handleSetUpTickets = () => setShowTicketSetup(true);

  const handleSkipTickets = () => {
    if (eventId) navigate(`/eo/events/${eventId}`);
    else handleGoToDashboard();
  };

  if (showTicketSetup && eventId) {
    return (
      <QuickTicketSetup
        eventId={eventId}
        eventName=""
        onClose={() => setShowTicketSetup(false)}
        onDone={() => { setShowTicketSetup(false); navigate(`/eo/events/${eventId}`); }}
      />
    );
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50 p-4">
      <div className="bg-white p-6 rounded-2xl shadow-xl max-w-sm w-full">
        <div className="flex justify-center mb-4">
          <CheckCircleIconSolid className="size-16 text-green-500" />
        </div>
        <h2 className="text-center text-lg font-bold text-grey-900 mb-1">
          {t('createEvent.eventPublished')}
        </h2>
        <p className="text-center text-sm text-grey-500 mb-6">
          Want to sell tickets to attendees?
        </p>

        {/* Ticket setup CTA */}
        <button
          onClick={handleSetUpTickets}
          className="w-full flex items-center justify-center gap-2 bg-primary-600 hover:bg-primary-700 text-white font-bold px-4 py-3 text-sm rounded-xl mb-3 transition"
        >
          <Ticket className="w-4 h-4" />
          Set Up Tickets
        </button>

        <div className="flex gap-2">
          <button
            className="flex-1 bg-grey-50 hover:bg-grey-100 text-grey-700 font-medium px-4 py-2.5 text-sm rounded-xl border border-grey-200 transition"
            onClick={() => handleClose()}
          >
            {t('createEvent.editEvent')}
          </button>
          <button
            className="flex-1 bg-grey-900 hover:bg-grey-800 text-white px-4 py-2.5 text-sm font-medium rounded-xl transition"
            onClick={handleSkipTickets}
          >
            {t('createEvent.goToDashboard')}
          </button>
        </div>
      </div>
    </div>
  );
};
export default ModalEventPublishedSuccess;
